import {
  createSlice,
} from '@reduxjs/toolkit';

export const LOADDERSTATUS = {
  INACTIVE: 'inactive',
  SHOWLOADDER: 'showLoadder',
  HIDELOADDER: 'hideLoadder',
};

const loadder = createSlice({
  name: 'loadder',
  initialState: {
    loadderStatus: LOADDERSTATUS.INACTIVE,
    loadderAcount: 0,
  },
  reducers: {
    showLoadder(state) {
      state.loadderStatus = LOADDERSTATUS.SHOWLOADDER;
      state.loadderAcount += 1;
    },
    hideLoadder(state) {
      const currentLoadderAcount = state.loadderAcount;
      if (currentLoadderAcount <= 1) state.loadderStatus = LOADDERSTATUS.HIDELOADDER;
      if (currentLoadderAcount > 0) state.loadderAcount -= 1;
    },
  },
});

export const {
  showLoadder, hideLoadder,
} = loadder.actions;

export default loadder.reducer;
